
{
  "familyId": "GET-VERH-VERDELEN",
  "questions": [
    {
      "id": "GET-VERH-VERDELEN-001",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Verdeel €120 in de verhouding 2 : 3. Hoeveel krijgt het grootste deel?",
      "options": [
        "€72",
        "€80",
        "€60",
        "€48"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "verh_verdelen_geld",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: bereken de waarde van 1 deel. Stap 1: Totaal delen: 2 + 3 = 5. Stap 2: 1 deel = €120 ÷ 5 = €24. Stap 3: Grootste deel (3): 3 × €24 = €72.",
        "distractorExplanations": {
          "0": "Goed! 120 ÷ 5 = 24 per deel. Grootste deel: 3 × 24 = €72.",
          "1": "Veelgemaakte fout: door 3 delen in plaats van door 5. 120 ÷ 3 = 40, × 2 = 80. Maar het totaal is 2 + 3 = 5 delen.",
          "2": "Veelgemaakte fout: halveren. 120 ÷ 2 = 60, maar de verhouding is 2:3, niet 1:1.",
          "3": "Veelgemaakte fout: het kleinste deel geven. 2 × 24 = €48 is het kleinste deel, niet het grootste."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-002",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Drie vrienden verdelen 45 snoepjes in de verhouding 1 : 2 : 6. Hoeveel krijgt de middelste?",
      "options": [
        "10",
        "15",
        "5",
        "30"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "verh_verdelen_drie",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: bereken 1 deel. Stap 1: Totaal delen: 1 + 2 + 6 = 9. Stap 2: 1 deel = 45 ÷ 9 = 5. Stap 3: Middelste (2 delen): 2 × 5 = 10.",
        "distractorExplanations": {
          "0": "Goed! 45 ÷ 9 = 5 per deel. Middelste: 2 × 5 = 10 snoepjes.",
          "1": "Veelgemaakte fout: door 3 delen. 45 ÷ 3 = 15, maar de verhouding is 1:2:6, niet gelijk.",
          "2": "Veelgemaakte fout: het kleinste deel geven. 1 × 5 = 5 is het kleinste deel.",
          "3": "Veelgemaakte fout: het grootste deel geven. 6 × 5 = 30 is het grootste deel."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-003",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Een mengsel bestaat uit zand en cement in de verhouding 4 : 1. Je hebt 25 kg nodig. Hoeveel kg zand gebruik je?",
      "options": [
        "20 kg",
        "24 kg",
        "5 kg",
        "100 kg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "verh_verdelen_materiaal",
      "variantIndex": 3,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: bereken 1 deel van het totaal. Stap 1: Totaal delen: 4 + 1 = 5. Stap 2: 1 deel = 25 ÷ 5 = 5 kg. Stap 3: Zand (4 delen): 4 × 5 = 20 kg.",
        "distractorExplanations": {
          "0": "Goed! 25 ÷ 5 = 5 per deel. Zand: 4 × 5 = 20 kg.",
          "1": "Veelgemaakte fout: 25 − 1 = 24. Maar cement is 1 deel van 5, niet 1 kg.",
          "2": "Veelgemaakte fout: het cement-deel geven. 1 × 5 = 5 kg is cement, niet zand.",
          "3": "Veelgemaakte fout: 25 × 4 = 100. Je vermenigvuldigt het deel (5 kg) met 4, niet het totaal."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-004",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Een klas van 30 leerlingen wordt verdeeld in de verhouding jongens : meisjes = 3 : 2. Hoeveel meisjes zijn er?",
      "options": [
        "12",
        "18",
        "15",
        "20"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "verh_verdelen_personen",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: bereken 1 deel. Stap 1: Totaal delen: 3 + 2 = 5. Stap 2: 1 deel = 30 ÷ 5 = 6. Stap 3: Meisjes (2 delen): 2 × 6 = 12.",
        "distractorExplanations": {
          "0": "Goed! 30 ÷ 5 = 6 per deel. Meisjes: 2 × 6 = 12.",
          "1": "Veelgemaakte fout: het jongens-deel geven. 3 × 6 = 18 is het aantal jongens, niet meisjes.",
          "2": "Veelgemaakte fout: halveren. 30 ÷ 2 = 15, maar de verhouding is 3:2, niet 1:1.",
          "3": "Veelgemaakte fout: door de verhouding delen. 30 ÷ 3 × 2 = 20. Maar je moet eerst het totaal delen bepalen: 3 + 2 = 5."
        }
      }
    }
  ]
}
